import { ActionIcon, ActionIconProps, Avatar } from '@mantine/core';
import styled from 'styled-components';

const TableEditButton = ({ onClick }: any) => {
  return (
    <div onClick={onClick}>
      <StyledActionIcon radius={50} size={40}>
        <Avatar src={'/assets/editIcon.png'} radius={0} size={24} />
      </StyledActionIcon>
    </div>
  );
};
export default TableEditButton;

const StyledActionIcon = styled(ActionIcon)<ActionIconProps>`
  background: transparent;
  &:hover {
    background: #E9EEF1;
  }
`;
